var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc2626",
    d: "m12 1 5 11h-3a2 2 0 1 0-4 0H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 23 5-11h-3a2 2 0 1 1-4 0H7z"
  }))));
};
export default SvgCompass;